export const gtagGoogleAnalyticsId = 'G-QZ6ZGLFPQV';
export const gtagGoogleAdsId = 'AW-789114793';
export const gtmId = 'GTM-KV2JZCRW';

export const DATADOG_CONFIG = {
  applicationId: 'cdda0edf-a6b9-4765-8e1d-263deef4902d',
  clientToken: 'pubfbfe8a19c4d45eb72152df453ab07a50',
  service: 'bznav-refund'
};
